'use client';

import { Link } from '@heroui/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch } from '@/hooks/redux';
import { COMMON_EVENTS, logHubxEvent } from '@/app/providers/analytics';
import usePaddlePricing from '@/features/subscription/hooks/usePaddlePricing';
import { setTypeForUserAccessLevel } from '@/store/slices/userAccessSlice';
import { setUploadIntent } from '@/features/tool/slices/uploadSlice';
import { PDF_ONLY_FILE_TYPES } from '@/features/tool/utils/uploadConstraints';
import { getPrimaryPrice } from '@/helpers/pricing-helper';

const HomeUploadCta = ({ label }: { label: string }) => {
  const dispatch = useAppDispatch();
  const { yearlyPrices, monthlyPrices, weeklyPrices } = usePaddlePricing();

  const showSideFunction = () => {
    dispatch(
      setUploadIntent({
        targetPath: '/app/edit-pdf?tool=edit-pdf',
        fileTypes: PDF_ONLY_FILE_TYPES,
        multiple: false,
      })
    );
    dispatch(setTypeForUserAccessLevel('home_start_trial'));
    const primaryPrice = getPrimaryPrice({
      yearlyPrices,
      monthlyPrices,
      weeklyPrices,
    });

    logHubxEvent({
      eventName: COMMON_EVENTS.PURCHASE_BUTTON_CLICK,
      event_params: {
        paywallType: 'home_start_trial',
        currency: primaryPrice?.unit_price?.currency_code,
        amount: (primaryPrice?.unit_price?.amount ?? 0) / 100,
        product_id: primaryPrice?.product_id!,
      },
    });
  };

  return (
    <Link
      onClick={() => showSideFunction()}
      className="mt-8 body-medium text-primary-light-blue  cursor-pointer hover:text-primary-dark-blue"
    >
      {label}
      <FontAwesomeIcon icon={['fas', 'arrow-right']} className="ml-[9px]" />
    </Link>
  );
};

export default HomeUploadCta;
